<template>
  <div>  
    <wc-dialog
      :loading='isLoading'
      :showDialog='showDialog'
      title='Inquiry'
      :icon='moduleData.icon'
      width='900'
      @cancel='cancel'
      @save='save'
      :disableButtons='!isFormValid'
      :fullscreen='$vuetify.breakpoint.smAndDown'
    >
      <v-form v-model='isFormValid' ref='form'>
        <v-row>
          <v-col cols='12' md='4'>
            <wc-data-box
              title='Contact'
              mini
              :titleIcon='$store.state.icons.modules.clients.icon'
              :titleIconColor='$store.state.icons.modules.clients.color'
            >
              <v-card-text>
                <v-text-field
                  label='First Name'
                  v-model='newInquiry.name'
                  dense
                  :disabled='newInquiry.existing_client ? true : false'
                  :rules='newInquiry.existing_client ? [] : [rules.required]'
                  hint='required'
                  persistent-hint
                ></v-text-field>
                <v-text-field
                  label='Last Name'
                  dense
                  v-model='newInquiry.last_name'
                ></v-text-field>
                <phone-number-field
                  icon='mdi-phone'
                  dense
                  label='Phone'
                  @update='updateCellPhone'
                ></phone-number-field>
                <v-text-field
                  prepend-icon='mdi-email'
                  dense
                  label='Email'
                  :rules="newInquiry.existing_client ? [] : [rules.email]"
                  v-model='newInquiry.email'
                ></v-text-field>
              </v-card-text>
            </wc-data-box>
          </v-col>

          <v-col cols='12' md='4'>
            <wc-data-box
              title='Site'
              mini
              :titleIcon='$store.state.icons.dataBox.address.icon'
              :titleIconColor='$store.state.icons.dataBox.address.iconColor'
            >
              <v-card-text>
                <v-text-field
                  dense
                  label='Address'
                  v-model='newInquiry.site_address'
                ></v-text-field>
                <v-text-field
                  dense
                  label='City'
                  v-model='newInquiry.site_city'
                ></v-text-field>
              </v-card-text>
            </wc-data-box>
            <wc-data-box
              class='mt-6'
              title='Staff to follow up'
              mini
              :titleIcon='$store.state.icons.modules.profile.icon'
              :titleIconColor='$store.state.icons.modules.profile.color'
            >
              <v-card-text>
                <v-autocomplete
                  dense
                  label='Assign to'
                  :items='profiles'
                  item-text='name_display'
                  item-value='id'
                  v-model='newInquiry.assigned_to'
                  :rules='[rules.required]'
                  hint='required'
                  persistent-hint
                ></v-autocomplete>
              </v-card-text>
            </wc-data-box>
          </v-col>
          <v-col cols='12' md='4'>
            <wc-data-box
              title='Primary Inquiry Type'
              :titleIcon='$store.state.icons.dataBox.divisions.icon'
              :titleIconColor='$store.state.icons.dataBox.divisions.iconColor'
              mini
            >
              <v-card-text>
                <v-select
                  v-model='newInquiry.division'
                  :items='this.divisions'
                  item-value='id'
                  item-text='division'
                ></v-select>
                <small>
                  If they are inquiring about multiple services, choose irrigation and indicate the additional services in the notes below.
                </small>
              </v-card-text>
            </wc-data-box>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols='12'>
            <wc-data-box
              title='Initial Conversation'
              mini
              titleIcon='mdi-forum'
              titleIconColor='purple'
            >
              <v-card-text>
                <v-textarea
                  outlined
                  class='mt-n2'
                  v-model='newInquiry.notes'
                ></v-textarea>
              </v-card-text>
            </wc-data-box>
          </v-col>
        </v-row>
      </v-form>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import formRules from '@/mixins/formRules';
import inquiriesAPI from '@/modules/inquiries/api/inquiries';
import staffingAPI from '@/modules/staffing/api/staffing';
import PhoneNumberField from '@/components/forms/PhoneNumberField';

export default {
  name: 'new-inquiry-dialog',
  mixins: [formRules],
  data: () => ({
    isLoading: true,
    isFormValid: false,
    profiles: [],
    search: '',
    headers: [
      { text: 'Date', value: 'date_created' },
      { text: 'Division', value: 'division' },
      { text: 'Contact', value: 'name' },
      { text: 'Created By', value: 'created_by' }
    ],
    newInquiry: {}
  }),
  props: {
    showDialog: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.getData()
  },
  computed: {
    moduleData () {
      return this.$store.state.icons.modules.inquiries
    },
    divisions () {
      return this.$store.state.misc.divisions
    }
  },
  watch: {
    showDialog () {
      if (this.showDialog) {
        this.$nextTick(() => {
          this.$refs.form.reset()
          this.newInquiry.existing_client = null
          this.newInquiry.existing_project = null
          this.newInquiry.name = ''
          this.newInquiry.last_name = ''
          this.newInquiry.email = ''
          this.newInquiry.home_phone = ''
          this.newInquiry.cell_phone = ''
          this.newInquiry.notes = ''
          this.newInquiry.site_address = ''
          this.newInquiry.site_city = ''
          this.newInquiry.created_by = this.$store.state.auth.profile.id
          let div = this.divisions.find(d => d.division === 'Irrigation')
          this.newInquiry.division = div.id
        })
      }
    },
  },
  methods: {
    async getData () {
      this.isLoading = true
      let profiles = await staffingAPI.getProfiles()
      let filtered = _.filter(profiles, 'is_active')
      let fp = _.filter(filtered, p => p.name_display != 'Matt Jullion' && p.name_display != 'Elijah MacLeod-Shaw' && p.name_display != 'POSTMARK')
      this.profiles = _.orderBy(fp, 'perms.length', 'desc')
      this.isLoading = false
    },
    async save () {
      this.isLoading = true
      this.newInquiry.created_by = this.$store.state.auth.profile.id
      await inquiriesAPI.createInquiry(this.newInquiry)
      this.cancel()
    },
    cancel () {
      this.$refs.form.reset()
      this.$emit('cancel')
    },
    updateCellPhone(phone){
      this.newInquiry.cell_phone = phone;
    }
  },
  components: {
    'phone-number-field': PhoneNumberField
  }
}
</script>
